/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSign } from '../../factoriesNumber.js';
export var signDependencies = {
  typedDependencies,
  createSign
};